import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import GearForm from './GearForm';
// import { initialValues  } from './initialValues-testing';
import { showGearApi, updateGearApi, clearEditedGear } from './gearSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { pictureAttributeNames } from './initialValue';
import uploadImage from '~/api/uploadImage';

function GearUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.itemSaga.gear);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (values) => {
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        await uploadImage(values, pictureAttributeNames, 'gears');
        dispatch(updateGearApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showGearApi({ navigate, id }));
        return () => dispatch(clearEditedGear());
    }, []);

    return (
        <GearForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default GearUpdate;
